import { render, staticRenderFns } from "./gd2022Devices.vue?vue&type=template&id=52101ae0&"
import script from "./gd2022Devices.vue?vue&type=script&lang=js&"
export * from "./gd2022Devices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports